module.exports = __webpack_public_path__ + "img/seplagLogoWhite.19f325a4.svg";